var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allibaba-container"},[(_vm.isAliUsing)?_c('ali-slide',{ref:"aliSlide",staticClass:"alli-slide",on:{"ali-slide-done-event":_vm.getAliSlideDoneValue}}):_c('grecaptcha',{on:{"locale-change-event":_vm.recapt_id_reset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }